import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMobileHeaderMap = styled('div')`
  height: 253px;
  font-family: ${(props) => props.theme.fontText};

  @media (max-width: ${breakpoints.lg}px) {
    height: calc(60dvh - 160px);
  }
  @media (max-width: ${breakpoints.md}px) {
    height: calc(70dvh - 160px);
  }
  @media (max-width: ${breakpoints.xs}px) {
    height: calc(80dvh - 160px);
  }

  #map-popup {
    font-family: ${(props) => props.theme.fontText};
    position: relative;
    right: 90px;
  }
`;
